$(function () {

  //Open External Links in new tab
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  //Hover On Menu
  // let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  // console.log(items)
  // items.forEach(item => {
  //   item.addEventListener("mouseover", () => {
  //     item.setAttribute("open", true);
  //     item.querySelector("ul").addEventListener("mouseleave", () => {
  //       item.removeAttribute("open");
  //     });
  //     item.addEventListener("mouseleave", () => {
  //       item.removeAttribute("open");
  //     });
  //   });

  // });

  // Slick Slider
  $('.section-collection-list .collection-list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 750,
        settings: 'unslick'
      }
    ]
  });
});